import { listContacts } from 'services/contact';
import { totalCountEvent } from 'services/generalServices';
import { getFilteredContacts } from 'modules/settings/workflow_automation/helpers/automationCommonHelpers';

export const loadLocations = (setLocationsList) => {
  totalCountEvent('contact').then((response) => {
    listContacts('', '', '', '', false, true, '', response.data)
      .then((response) => {
        if (response?.data?.contacts?.length > 0) {
          let options = response.data.contacts.map((index) => {
            let locatonName = index.title ? index.title : index.office_name;
            return {
              label: locatonName,
              value: index?.contact_id || index?.office_location_id,
            };
          });
          setLocationsList([...options]);
        }
      })
      .catch((err) => {
        console.log('err', err);
      });
  });
};

export const getFormattedAttendees = (params) => {
  const { attendeesArr = [], isBillingOrPrimary = false, isUserGroup = false, isFirmUser = true, isTeamMember } = params || {};
  let formatttedAttendeesArr = [];
  let filteredAttendees = [];

  //Filtering attendees selected
  filteredAttendees = getFilteredContacts({
    arrayToBeFiltered: attendeesArr,
    isBillingOrPrimary,
    isFirmUser,
    isUserGroup,
    isTeamMember,
  });

  formatttedAttendeesArr = filteredAttendees?.map((attendee, idx) => {
    if (attendee?.email) {
      // Firm users only
      // const { label: fullName, value: congnitoUserName, contact_id, email, is_attendance_required } = attendee;
      const {
        label: fullName,
        value,
        contact_id,
        email,
        is_attendance_required,
        client_cognito_username,
        firm_user_id,
        access_level,
        profile_image,
      } = attendee;

      return {
        name: fullName,
        email,
        cognito_username: client_cognito_username,
        contact_id,
        firm_user_id,
        access_level,
        profile_image,
        is_attendance_required,
      };
    } else if (attendee?.group_id) {
      // User group items only
      const { label: groupName, pk, group_id, sk } = attendee || {};
      return {
        group_name: groupName,
        sk: sk,
        group_id,
        pk,
      };
    } else if (attendee?.code && attendee?.code === 'TEAM_MEMBER_ROLE') {
      //Team member roles only
      return attendee?.value;
    }

    // primary and billing contacts only
    return attendee?.value;
  });
  return formatttedAttendeesArr;
};

/** --- generateFullAttendeesList - function generates full "Attendees" list including Primary and Billing Contacts--- **/
export const generateFullAttendeesList = (params = {}) => {
  const { firmUsersList = [], setFullAttendeesList = () => {}, getAllRequiredContactsList = () => {} } = params || {};
  let allAttendees = getAllRequiredContactsList(firmUsersList);
  setFullAttendeesList(allAttendees);
};
export const generateFullAttendeesListReverse = (params = {}) => {
  const { firmUsersList = [], setFullAttendeesList = () => {}, getAllRequiredContactsList = () => {} } = params || {};
  let allAttendees = getAllRequiredContactsList(firmUsersList);
  setFullAttendeesList(allAttendees.reverse());
};

/** --- Generating attendee details object array --- **/
export const generateAttendeesStatusOptions = (params) => {
  const { fullAttendeesList: fullAttendees, attendeesWatched: selectedAttendees } = params || {};

  let statusArr = [];
  let allContactList = [];

  if (fullAttendees?.length > 0) {
    fullAttendees?.forEach((element) => {
      if (element?.items?.length) {
        allContactList.push(...element?.items);
      }
    });
  }

  if (selectedAttendees?.length && allContactList?.length) {
    selectedAttendees?.forEach((att, idx) => {
      allContactList?.forEach((attendee, index) => {
        let condition = att === attendee?.value;
        if (condition) {
          statusArr.push(attendee);
        }
      });
    });
  }

  return statusArr;
};
